import WidgetBase from '@dojo/widget-core/WidgetBase';
import { DNode } from '@dojo/widget-core/interfaces';
import { v } from '@dojo/widget-core/d';

import * as css from './styles/ActionList.m.css';
import * as parentcss from './styles/Ticker.m.css';

import Ticker, {team}  from './Ticker';
import util from '../util';

import StatisticManager from '../StatisticManager';
import { VideoListProperties, VideoList } from './VideoList';

const GelbeKarte = require('./../img/GelbeKarte.svg');
const RoteKarte = require('./../img/RoteKarte.svg');
const SiebenMeterTreffer = require('./../img/SiebenMeterTreffer.svg');
const SiebenMeterDaneben = require('./../img/SiebenMeterDaneben.svg');
const Tor = require('./../img/Tor.svg');
const ZweiMinuten = require('./../img/ZweiMinuten.svg');
const Auszeit = require('./../img/GrueneKarte.svg');
const Trophy = require('./../img/Trophy.svg');

export interface ActionListParent {
    parent: Ticker;
    actions: ActionListProperties;
    videos: VideoListProperties;
}

export interface ActionElementProperties {
    game_time: string,
    home_score: string,
    guest_score: string,
    message: string,
    status: number,
    status_description: string,
    stops_time: boolean,
}

export interface ActionListProperties {
    actionElements: ActionElementProperties[];
    loaded: boolean;
    isLastRefresh: boolean;
}

export class ActionList extends WidgetBase<ActionListParent> {

	protected render() {
        
        var shownLines=[] as DNode[];
        
        // console.log("ActionList#render");

        StatisticManager.reset();
        
        var actionIndex = 0;
        var videoIndex = 0;
        
        while (actionIndex < this.properties.actions.actionElements.length
            || videoIndex < this.properties.videos.videoElements.length) {
                
            var type = 'X';
            if (actionIndex == this.properties.actions.actionElements.length) {
                type = 'V';
            } else if (videoIndex == this.properties.videos.videoElements.length) {
                type = 'A';
            }
            else {
                let actionSeconds = Number(this.properties.actions.actionElements[actionIndex].game_time);
                let videoSeconds = this.properties.videos.videoElements[videoIndex].context.seconds;
                type = (actionSeconds < videoSeconds? 'A' : 'V');
                // console.log("action: "+actionSeconds+", video: "+videoSeconds+": decide for "+type);
            }
            
            if (type == 'A') {
                shownLines.unshift(this.generateActionLine(this.properties.actions.actionElements[actionIndex], actionIndex));
                actionIndex++;
            } else if (type == 'V') {
                shownLines.unshift(VideoList.generateVideoLine(this.properties.videos.videoElements[videoIndex], videoIndex));
                videoIndex++;
            } else {
                console.error("Type neither A nor V (is "+type+")???");
                break;
            }
        }
        
        if (this.properties.actions.isLastRefresh) {
            shownLines.unshift(
            );
        }
        
        return v('div', { classes: css.tabbody }, shownLines );
	}


    protected generateActionLine(line: ActionElementProperties, lineNumber:number) : DNode {

        var actionS = line.message;
        var actionL = line.message;
        var symbol = undefined;
        var displayAt: number;
        var playerName: string;
        var lastGametime:string = "";
        var lastAction:string = "";

        // Filter out double lines that somehow still happen
        if (line.game_time==lastGametime && line.message==lastAction) {
            return;
        }
        lastGametime=line.game_time;
        lastAction=line.message;

        if      (actionL.indexOf("Heimmannschaft")!=-1) { displayAt=1; }
        else if (actionL.indexOf("Gastmannschaft")!=-1) { displayAt=2; }
        else if (actionL.substring(0, 10) == "Spielstand") { displayAt=0; }
        else { return; }

        var time = util.formatTime(Number(line.game_time));
        var shirtNo;

        if (line.message.indexOf("Auszeit")!=-1) {
            actionL="Mannschafts-Auszeit"; 
            actionS="Auszeit";
            symbol=Auszeit;
        }
        else if (line.message.substring(0, 3) == "Tor") {
            shirtNo = line.message.substring(43).trim();
            playerName = this.getPlayerName(shirtNo, displayAt);
            actionS="Tor durch "+line.message.substring(43)+" "+playerName; 
            actionL="Tor durch "+line.message.substring(33)+" "+playerName;
            symbol=Tor;
            StatisticManager.addGoal(displayAt, shirtNo);
        }
        else if (line.message.substring(0, 10) == "Verwarnung") {
            shirtNo = line.message.substring(25, 28).trim();
            playerName = this.getPlayerName(shirtNo, displayAt);
            actionS=line.message.substring(0, 14) + line.message.substring(25, 28)+" "+playerName;
            actionL=line.message.substring(0, 28)+" "+playerName;
            symbol=GelbeKarte;
            StatisticManager.addWarning(displayAt, line.message.substring(25, 28), time);
        }
        else if (line.message.substring(0, 16) == "Erfolgreicher 7m") {
            shirtNo = line.message.substring(62).trim();
            playerName = this.getPlayerName(shirtNo, displayAt);
            actionS="7m Tor durch "+line.message.substring(62)+" "+playerName;
            actionL="7m Tor "+line.message.substring(45)+" "+playerName;
            symbol=SiebenMeterTreffer;
            StatisticManager.addScored7m(displayAt, line.message.substring(62));
        }
        else if (line.message.substring(0, 7 ) == "7m-Wurf") {
            shirtNo = line.message.substring(62).trim();
            playerName = this.getPlayerName(shirtNo, displayAt);
            actionS="7m durch "+line.message.substring(62)+" "+playerName;
            actionL="7m "+line.message.substring(45)+" "+playerName;
            symbol=SiebenMeterDaneben;
            StatisticManager.addMissed7m(displayAt, line.message.substring(62));
        }
        else if (line.message.substring(0, 12) == "2-min Strafe") {
            shirtNo = line.message.substring(27, 30).trim();
            playerName = this.getPlayerName(shirtNo, displayAt);
            actionS="2 min f\u00fcr "+line.message.substring(27, 30)+" "+playerName;
            actionL=line.message.substring(0, 30)+" "+playerName;
            symbol=ZweiMinuten;
            StatisticManager.addTimeout(displayAt, line.message.substring(27, 30), time);
        }
        else if (line.message.substring(0, 28) == "Disqualifikation mit Bericht") {
            shirtNo = line.message.substring(43, 46).trim();
            // console.log("shirtNo='"+shirtNo+"'");
            playerName = this.getPlayerName(shirtNo, displayAt);
            actionS="Blaue Karte f\u00fcr" + line.message.substring(31, 34)+" "+playerName;
            actionL=line.message.substring(0, 32)+" "+shirtNo+' '+playerName;           // 'die Nummer' hier weglassen weil 'mit Bericht' sonst zu viel Platz braucht
            symbol=RoteKarte;
            StatisticManager.addDisqualify(displayAt, shirtNo, time);
        }
        else if (line.message.substring(0, 16) == "Disqualifikation") {
            shirtNo = line.message.substring(31, 34).trim();
            playerName = this.getPlayerName(shirtNo, displayAt);
            actionS="Rote Karte f\u00fcr" + line.message.substring(31, 34)+" "+playerName;
            actionL=line.message.substring(0, 34)+" "+playerName;
            symbol=RoteKarte;
            StatisticManager.addDisqualify(displayAt, shirtNo, time);
        }
        else if (line.message.substring(0, 10) == "Spielstand") {
            actionL=actionS="Spielstand";
            if (line.home_score == line.guest_score) {
                symbol="";
            } else {
                symbol=Trophy;

                if (parseInt(line.home_score) > parseInt(line.guest_score)) {
                    displayAt = 1;
                } else {
                    displayAt = 2;
                }
            }
        }

        var image:DNode;
        if (symbol==undefined) {
            image="";
        } else {
            image=v('img', { src: symbol, classes: [parentcss.actioniconimage] });
        }

        this.properties.parent.setResultAndTime(line.home_score, line.guest_score, time);

        return(
            v('div', {classes: [css.tabbodyrow], key: "action#" + lineNumber }, [
                // v('div',        { classes: [ parentcss.tabbodycell, parentcss.time       ] },   [ time ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actiontext, parentcss.right, parentcss.hideifsmall ] },  [ displayAt != 2 ? actionL : "" ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actiontext, parentcss.left, parentcss.hideifwide ] },    [ actionS ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actioniconleft ] },   [ displayAt == 1 ? image : "" ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.restime  ] },   [ 
                    v('div',    {classes:  [ parentcss.time]}, [ time ]),
                    v('div',    {classes:  [ parentcss.result ]}, [ line.home_score+":"+line.guest_score ])
                ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actioniconright ] },   [ displayAt == 2 ? image : "" ]),
                v('div',        { classes: [ parentcss.tabbodycell, parentcss.actiontext, parentcss.left, parentcss.hideifsmall ] },   [ displayAt != 1 ? actionL : "" ]),
                //v('div',        { classes: [ parentcss.tabbodycell, parentcss.time, parentcss.hideifsmall ] },   [  ]),
            ])
        );
    }

    private getPlayerName(shirtNo: string, teamNo: number):string {
        // console.log("get player name for team "+teamNo+" shirt no "+shirtNo);
        if (this.properties.parent == null || this.properties.parent.detailInfo == null) {
            return "";
        }
        var teamInfo:team|null = null;
        if (teamNo == 1) {
            teamInfo = this.properties.parent.detailInfo.team_home;
        } else if (teamNo == 2) {
            teamInfo = this.properties.parent.detailInfo.team_guest;
        }
        if (teamInfo == null) {
            return "";
        }
        for (var i = 0; i < teamInfo.team_members.length; i++) {
            if (teamInfo.team_members[i].player_no == shirtNo) {
                var prename = teamInfo.team_members[i].prename;
                var name    = teamInfo.team_members[i].name;
                if (prename == "N.N.") { prename="";} else { prename=prename+" "; }
                if (name    == "N.N.") { name   ="";}
                return prename+name;
            }
        }
        return "";
    }
}

export default ActionList;



// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/widgets/ActionList.ts